import * as Yup from 'yup'

const validationSchemasRespuesta = Yup.object({
     fechaRespuesta:Yup.date().required("La Fecha es obligatoria"),
     respuesta:Yup.string().required("Debe elegir una respuesta..."),
     motivoRespuestaCIA:Yup.string().required("Debe elegir un motivo..."),
     porcConvenio:Yup.number().min(0, "El porciento no puede ser negativo").max(100,"El porciento no puede ser mayor a 100"),
})
export default validationSchemasRespuesta;